import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCallback = () => {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login");
            return;
        }
        const sessionId = decodeURIComponent(m[1]);
        api.post("/auth/session", { session_id: sessionId })
            .then((r) => {
                window.history.replaceState(null, "", "/profile");
                navigate("/profile", {
                    replace: true,
                    state: { user: r.data.user },
                });
            })
            .catch(() => navigate("/login"));
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bb-night-bg">
            <p className="text-[#b0b8d6]">Weaving moonlight…</p>
        </div>
    );
};

export default AuthCallback;
